/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export class Variance {
	public $id: string;
	public varianceColor?: string;
	public varianceKey?: number;
	public varianceReason?: string;
	public combinedVarianceText?: string;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public constructor(obj: any, key: string) {
		this.$id = key;
		this.update(obj);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public update(obj: any): void {
		this.varianceColor = obj.varianceColor;
		this.varianceKey = obj.varianceKey;
		this.varianceReason = obj.varianceReason;
		this.combinedVarianceText = this.varianceKey + '. ' + this.varianceReason;
	}
}
